<template>
    <div class="my-order">
        <mt-navbar v-model="selected" :fixed="true">
            <mt-tab-item @click.native="navbarItemClick" id="-1">全部</mt-tab-item>
            <mt-tab-item @click.native="navbarItemClick" id="0">待付款</mt-tab-item>
            <!-- <mt-tab-item @click.native="navbarItemClick" id="1">已付款</mt-tab-item> -->
            <mt-tab-item @click.native="navbarItemClick" id="2">待收货</mt-tab-item>
            <mt-tab-item @click.native="navbarItemClick" id="3">已完成</mt-tab-item>
        </mt-navbar>
        
        <!-- tab-container -->
        <mt-tab-container v-model="selected" v-infinite-scroll="loadMoreInfo"
                            infinite-scroll-disabled="aloading"
                            infinite-scroll-distance="10">
            <mt-tab-container-item id="-1">
                <div class="list-table" v-for="(item) in all_order" :key="item.id">
                    <div class="tab-header">
                        <div>订单号：<span>{{item.ID}}</span></div>
                        <div>
                            <span v-if="item.State == 0">等待付款</span>
                            <span v-if="item.State >0&&item.State <=2">等待收货</span>
                            <span v-if="item.State == 3">已完成</span>
                        </div>
                    </div>
                    <div class="tab-school">
                        <div class="area">
                            <div>销售区域：</div>
                            <div>{{item.AreaName}}</div>
                        </div>
                        <div class="time-num" v-if="item.State == 2">
                            <div style="font-size: 14px;">快递：{{item.Express}}</div>
                            <div>
                                <span style="font-size: 14px;">快递单号：</span>
                                <span style="font-size: 14px;">{{item.ExpressNo}}</span>
                            </div>
                        </div>
                        <div class="detail">
                            <div><img src="../../assets/img/mouse1.jpg" alt=""/></div>
                            <div>备课小助手是一款将扫描功能置于鼠标内的智能设备，具备三维拼接图技术、OCR识别、AI人工智能识别，快速组卷功能及千万级题库备课资源、</div>
                        </div>
                        <div class="time-num">
                            <div>{{item.datas}}</div>
                            <div>
                                <span class="num">共{{item.MouseCount}}件商品</span>
                                <span v-if="item.State ==0">应付款：<span class="price">￥{{item.Moneys}}</span></span>
                                <span v-if="item.State > 0">实付款：<span class="price">￥{{item.Moneys}}</span></span>
                            </div>
                        </div>
                    </div>
                    <div class="tab-bot">
                        <!-- <div class="mouse-num">共{{item.MouseCount}}个手持扫描设备</div> -->
                        <div class="cancel-pay" v-if="item.State == 0" @click="cancelClickEvent(item)">删除订单</div>
                        <div class="fin-pay" v-if="item.State == 0" @click="confirmClickEvent(item)">完成支付</div>
                        <div class="cancel-pay" v-if="item.State == 2||item.State == 1" @click="cancelGetGoods(item)">取消订单</div>
                        <div class="fin-pay" v-if="item.State == 2" @click="confirmGetGoods(item)">确认收货</div>
                        <div class="fin-pay" v-if="item.State == 1" @click="remindBoseGoods(item)">我要催单</div>
                        <div class="fin-pay" v-if="item.State == 3" @click="buyAgain(item)">再次购买</div>
                    </div>
                </div>
                <h3 v-if="all_order.length<=0">暂无订单</h3>
                <p v-if="show_line&&all_order.length!=0" class="data-base-line">到底了</p>
            </mt-tab-container-item>
            <mt-tab-container-item id="0">
                <div class="list-table" v-for="(item) in unpaid_order" :key="item.id">
                    <div class="tab-header">
                        <div>订单号：<span>{{item.ID}}</span></div>
                        <div><span>等待付款</span></div>
                    </div>
                    <div class="tab-school">
                        <div class="area">
                            <div>销售区域：</div>
                            <div>{{item.AreaName}}</div>
                        </div>
                        <div class="detail">
                            <div><img src="../../assets/img/mouse1.jpg" alt=""/></div>
                            <div>备课小助手是一款将扫描功能置于鼠标内的智能设备，具备三维拼接图技术、OCR识别、AI人工智能识别，快速组卷功能及千万级题库备课资源、</div>
                        </div>
                        <div class="time-num">
                            <div>{{item.datas}}</div>
                            <div>
                                <span class="num">共{{item.MouseCount}}件商品</span>
                                <span>应付款：<span class="price">￥{{item.Moneys}}</span></span>
                            </div>
                        </div>
                    </div>
                    <div class="tab-bot">
                        <div class="cancel-pay" @click="cancelClickEvent(item)">删除订单</div>
                        <div class="fin-pay" @click="confirmClickEvent(item)">完成支付</div>
                    </div>
                </div>
                <h3 v-if="unpaid_order.length<=0">暂无待支付订单</h3>
                <p v-if="show_line&&unpaid_order.length!=0" class="data-base-line">到底了</p>
            </mt-tab-container-item>
            <mt-tab-container-item id="2">
                <div class="list-table" v-for="(item) in paid_order" :key="item.id">
                    <div class="tab-header">
                        <div>订单号：<span>{{item.ID}}</span></div>
                        <div><span v-if="item.State == 1">正在出库</span><span v-if="item.State == 2">已出库,等待收货</span></div>
                    </div>
                    <div class="tab-school">
                        <div class="area">
                            <div>销售区域：</div>
                            <div>{{item.AreaName}}</div>
                        </div>
                        <div class="time-num" v-if="item.State == 2">
                            <div style="font-size: 14px;">快递：{{item.Express}}</div>
                            <div>
                                <span style="font-size: 14px;">快递单号：</span>
                                <span style="font-size: 14px;">{{item.ExpressNo}}</span>
                            </div>
                        </div>
                        <div class="detail">
                            <div><img src="../../assets/img/mouse1.jpg" alt=""/></div>
                            <div>备课小助手是一款将扫描功能置于鼠标内的智能设备，具备三维拼接图技术、OCR识别、AI人工智能识别，快速组卷功能及千万级题库备课资源、</div>
                        </div>
                        <div class="time-num">
                            <div>{{item.datas}}</div>
                            <div>
                                <span class="num">共{{item.MouseCount}}件商品</span>
                                <span>实付款：<span class="price">￥{{item.Moneys}}</span></span>
                            </div>
                        </div>
                    </div>
                    <div class="tab-bot">
                        <!-- <div class="mouse-num">共{{item.MouseCount}}个手持扫描设备</div> -->
                        <div class="cancel-pay" @click="cancelGetGoods(item)">取消订单</div>
                        <div class="fin-pay" v-if="item.State == 2" @click="confirmGetGoods(item)">确认收货</div>
                        <div class="fin-pay" v-if="item.State == 1" @click="remindBoseGoods(item)">我要催单</div>
                        <div class="fin-pay" @click="buyAgain(item)">再次购买</div>
                    </div>
                </div>
                <h3 v-if="paid_order.length<=0">暂无待收货订单</h3>
                <p v-if="show_line&&paid_order.length!=0" class="data-base-line">到底了</p>
            </mt-tab-container-item>
            <mt-tab-container-item id="3">
                <div class="list-table" v-for="(item) in all_complete" :key="item.id">
                    <div class="tab-header">
                        <div>订单号：<span>{{item.ID}}</span></div>
                        <div><span>已完成</span></div>
                    </div>
                    <div class="tab-school">
                        <div class="area">
                            <div>销售区域：</div>
                            <div>{{item.AreaName}}</div>
                        </div>
                        <div class="detail">
                            <div><img src="../../assets/img/mouse1.jpg" alt=""/></div>
                            <div>备课小助手是一款将扫描功能置于鼠标内的智能设备，具备三维拼接图技术、OCR识别、AI人工智能识别，快速组卷功能及千万级题库备课资源、</div>
                        </div>
                        <div class="time-num">
                            <div>{{item.datas}}</div>
                            <div>
                                <span class="num">共{{item.MouseCount}}件商品</span>
                                <span>实付款：<span class="price">￥{{item.Moneys}}</span></span>
                            </div>
                        </div>
                        <div class="tab-bot">
                            <div class="fin-pay" @click="buyAgain(item)">再次购买</div>
                        </div>
                    </div>
                </div>
                <h3 v-if="all_complete.length<=0">暂无已完成订单</h3>
                <p v-if="show_line&&all_complete.length!=0" class="data-base-line">到底了</p>
            </mt-tab-container-item>
        </mt-tab-container>
    </div>
</template>

<script>
import {MessageBox} from 'mint-ui';
export default {
    data() {
        return{
            selected: '-1',
            // 审核列表
            all_order: [],
            // 待支付
            unpaid_order: [],
            // 已支付
            paid_order: [],
            // 已完成
            all_complete: [],
            aloading: false,
            reqData: {
                State: -1,
                PageIndex: 0,
                PageSize: 15
            },
            show_line: false
        }
    },
    methods: {
        navbarItemClick() {
            let _this = this;
            _this.$indicator.open('加载中...');
            _this.aloading = true;
            _this.show_line = false;
            _this.reqData.State = Number(_this.selected);
            _this.reqData.PageIndex = 1;
            if(_this.reqData.State == -1) {
                _this.reqData.State = [0,1,2,3,4,5]
            }else if(_this.reqData.State == 2){
                _this.reqData.State = [1,2]
            }else if(_this.reqData.State == 3){
                _this.reqData.State = [3,4,5]
            }else{
                _this.reqData.State = [_this.reqData.State]
            }
            _this.abp.api.OutLogListByState(_this.reqData)
                .then((res)=> {
                    _this.$indicator.close();
                    if(res.status == 200) {
                        if(res.data.IsSuccess) {
                            if(res.data.Data.SaleLog.length < _this.reqData.PageSize) {
                                _this.aloading = true;
                                _this.show_line = true;
                            }else{
                                this.aloading = false;
                            }
                            res.data.Data.SaleLog.forEach(ele => {
                                ele.datas = _this.$moment(ele.CreateDate).calendar();
                            })
                            if(_this.selected == -1) {
                                // 清空其它列表
                                _this.unpaid_order = [];
                                _this.paid_order = [];
                                _this.all_complete = [];
                                _this.all_order = res.data.Data.SaleLog;
                            }else if(_this.selected == 2) {
                                // 清空其它列表
                                _this.all_order = [];
                                _this.unpaid_order = [];
                                _this.all_complete = [];
                                _this.paid_order = res.data.Data.SaleLog;
                            }else if(_this.selected == 3) {
                                // 清空其它列表
                                _this.all_order = [];
                                _this.unpaid_order = [];
                                _this.paid_order = [];
                                _this.all_complete = res.data.Data.SaleLog;
                            } else {
                                // 清空其它列表
                                _this.all_order = [];
                                _this.all_complete = [];
                                _this.paid_order = [];
                                _this.unpaid_order = res.data.Data.SaleLog;
                            }
                        }else{
                            _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                        }
                    }
                })
                .catch((error)=>{
                    _this.$indicator.close();
                    try {
                        switch(error.status) {
                            case 401:
                            _this.abp.api.reqSuccess(_this,'您没有权限！')
                        }
                    } catch (txt) {
                        console.log(txt);
                    }
                })
        },
        loadMoreInfo() {
            let _this = this;
            this.aloading = true;
            _this.$indicator.open('加载中...');
            _this.reqData.State = Number(_this.selected);
            _this.reqData.PageIndex = (_this.reqData.PageIndex+1);
            if(_this.reqData.State == -1) {
                _this.reqData.State = [0,1,2,3,4,5]
            }else if(_this.reqData.State == 2){
                _this.reqData.State = [1,2]
            }else if(_this.reqData.State == 3){
                _this.reqData.State = [3,4,5]
            }else{
                _this.reqData.State = [_this.reqData.State]
            }
            _this.abp.api.OutLogListByState(_this.reqData)
                .then((res)=> {
                    _this.$indicator.close();
                    if(res.status == 200) {
                        if(res.data.IsSuccess) {
                            if(res.data.Data.SaleLog.length < _this.reqData.PageSize) {
                                _this.show_line = true;_this.aloading = true;
                            }else{
                                this.aloading = false;
                            }
                            res.data.Data.SaleLog.forEach(ele => {
                                ele.datas = _this.$moment(ele.CreateDate).calendar();
                            })
                            if(_this.selected == -1) {
                                _this.all_order = _this.all_order.concat(res.data.Data.SaleLog);
                            }else if(_this.selected == 2) {
                                _this.paid_order = _this.paid_order.concat(res.data.Data.SaleLog);
                            }else if(_this.selected == 3) {
                                _this.all_complete = _this.all_complete.concat(res.data.Data.SaleLog);
                            } else {
                                _this.unpaid_order = _this.unpaid_order.concat(res.data.Data.SaleLog);
                            }
                        }else{
                            _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                        }
                    }
                })
                .catch((error)=>{
                    _this.$indicator.close();
                    try {
                        switch(error.status) {
                            case 401:
                            _this.abp.api.reqSuccess(_this,'您没有权限！')
                        }
                    } catch (txt) {
                        console.log(txt);
                    }
                })
        },
        // 完成订单
        confirmClickEvent(ele) {
            let _this = this;
            _this.$indicator.open('加载中...');
            _this.abp.api.WXAgentCreateOrder({out_trade_no:ele.ID})
                .then((res)=> {
                    _this.$indicator.close();
                    if(res.status == 200) {
                        if(res.data.IsSuccess) {
                            _this.onBridgeReady(res.data.Data)
                        }else{
                            _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                        }
                    }
                })
                .catch((error)=>{
                    _this.$indicator.close();
                    try {
                        switch(error.status) {
                            case 401:
                            _this.abp.api.reqSuccess(_this,'您没有权限！')
                        }
                    } catch (txt) {
                        console.log(txt);
                    }
                })
        },
        onBridgeReady(data) {
            let _this = this,
                paydata = data,
                appid = _this.abp.UserInfos.agentWxgzhConfig.AppID;
            // 现在暂时是老师支付
            if(data) {
                try{
                    if(paydata.nonceStr){
                        _this.$indicator.close();
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', {
                                "appId": appid,     //公众号名称，由商户传入     
                                "timeStamp": paydata.timeStamp,         //时间戳，自1970年以来的秒数     
                                "nonceStr": paydata.nonceStr, //随机串     
                                "package": paydata.package,     
                                "signType": "MD5",         //微信签名方式：     
                                "paySign": paydata.paySign //微信签名 
                            },
                            function(res){
                                if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                                    // 使用以上方式判断前端返回,微信团队郑重提示：
                                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                    _this.abp.api.reqSuccess(_this,'支付成功')
                                }else if(res.err_msg == "get_brand_wcpay_request:cancel" ) {
                                    _this.abp.api.reqSuccess(_this,'您取消支付了')
                                }else if(res.err_msg == "get_brand_wcpay_request:fail" ) {
                                    _this.abp.api.reqSuccess(_this,'订单支付失败了')
                                }else{
                                    _this.abp.api.reqSuccess(_this,'支付缺少参数')
                                }
                                _this.navbarItemClick();
                            }
                        );
                    }else{
                        _this.$indicator.close();
                        _this.abp.api.reqSuccess(_this,'订单创建有误')
                    }
                } catch (txt) {
                    _this.$indicator.close();
                }
            } else {
                _this.$indicator.close();
                _this.abp.api.reqSuccess(_this,'订单创建有误')
            }
        },
        // 删除订单
        cancelClickEvent(ele) {
            let _this = this;
            _this.$messagebox({
                title: '温馨提示',
                message: '确定要取消订单吗？',
                showCancelButton: true,
                confirmButtonText:"确定",
                cancelButtonText:"手误"
            }).then(action => {
                if(action == 'confirm'){
                    _this.$indicator.open('加载中...');
                    _this.abp.api.DeleteNoPayOrder(ele.ID)
                        .then((res)=> {
                            _this.$indicator.close();
                            if(res.status == 200) {
                                if(res.data.IsSuccess) {
                                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                    setTimeout(() => {
                                        _this.navbarItemClick()
                                    }, 2000);
                                }else{
                                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                }
                            }
                        })
                        .catch((error)=>{
                            _this.$indicator.close();
                            try {
                                switch(error.status) {
                                    case 401:
                                    _this.abp.api.reqSuccess(_this,'您没有权限！')
                                }
                            } catch (txt) {
                                console.log(txt);
                            }
                        })
                }else{
                    console.log('点击手误')
                }
            })
        },
        // 确认收货
        confirmGetGoods(ele) {
            let _this = this;
            this.$messagebox({
                title: '温馨提示',
                message: '确认收货吗？',
                showCancelButton: true,
                confirmButtonText:"确定",
                cancelButtonText:"手误"
            }).then(action => {
                if(action == 'confirm'){
                    _this.$indicator.open('加载中...');
                    _this.abp.api.ConfirmReceive({
                        ID: ele.ID,
                        // 收货时间
                        ReceiveDate: _this.$moment().format('YYYY-MM-DD[T]HH:mm:ss')
                    }).then((res)=> {
                            _this.$indicator.close();
                            if(res.status == 200) {
                                if(res.data.IsSuccess) {
                                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                    setTimeout(() => {
                                        _this.navbarItemClick()
                                    }, 2000);
                                }else{
                                    _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                }
                            }
                        })
                        .catch((error)=>{
                            _this.$indicator.close();
                            try {
                                switch(error.status) {
                                    case 401:
                                    _this.abp.api.reqSuccess(_this,'您没有权限！')
                                }
                            } catch (txt) {
                                console.log(txt);
                            }
                        })
                }else{
                    console.log('点击手误')
                }
            })
        },
        // 取消订单
        cancelGetGoods () {
            let _this = this;
            this.$messagebox({
                title: '温馨提示',
                message: '确定取消订单吗？',
                showCancelButton: true,
                confirmButtonText:"确定",
                cancelButtonText:"手误"
            }).then(action => {
                if(action == 'confirm'){
                    _this.abp.api.reqSuccess(_this,'您的订单正在出库，请与客服联系')
                }
            })
        },
        // 再次购买
        buyAgain(e) {
            let _this = this
                ,order_info = e;
            MessageBox.prompt(null,'请输入鼠标数量(整数)')
                .then(({ value, action})=>{
                    if(/^[0-9]*$/.test(value)) {
                        let reqData = {
                            AreaID: order_info.AreaID,
                            AreaName: order_info.AreaName,
                            Summary: order_info.Summary,
                            MouseCount: value,
                            AddressID: order_info.AddressID,
                            SchoolID: order_info.SchoolID,
                            SchoolName: order_info.SchoolName
                        };
                        _this.$indicator.open('加载中...');
                        _this.abp.api.CreateOutBatch(reqData)
                            .then((res) => {
                                if(res.status == 200) {
                                    if(res.data.IsSuccess) {
                                        _this.onBridgeReady(res.data.Data);
                                    }else{
                                        _this.$indicator.close();
                                        _this.abp.api.reqSuccess(_this,res.data.OutputMessage)
                                    }
                                }
                            })
                            .catch((error)=>{
                                _this.$indicator.close();
                                try {
                                    switch(error.status) {
                                        case 401:
                                        _this.abp.api.reqSuccess(_this,'您没有权限！')
                                    }
                                } catch (txt) {
                                    console.log(txt);
                                }
                            })
                    }else{
                        _this.abp.api.reqSuccess(_this,'请输入正确的数量格式')
                    }
				}).catch(err=>{
					console.log(err);
				})
        },
        // 我要催单
        remindBoseGoods() {
            let _this = this;
            _this.abp.api.reqSuccess(_this,'已提醒商家优先为您发货,谢谢您的配合!')
        },
        onBridgeReady(data) {
            let _this = this,
                paydata = data,
                appid = _this.abp.UserInfos.agentWxgzhConfig.AppID;
            // 现在暂时是老师支付
            if(data) {
                try{
                    if(paydata.nonceStr){
                        _this.$indicator.close();
                        WeixinJSBridge.invoke(
                            'getBrandWCPayRequest', {
                                "appId": appid,     //公众号名称，由商户传入     
                                "timeStamp": paydata.timeStamp.toString(),         //时间戳，自1970年以来的秒数     
                                "nonceStr": paydata.nonceStr, //随机串     
                                "package": paydata.package,     
                                "signType": "MD5",         //微信签名方式：     
                                "paySign": paydata.paySign //微信签名 
                            },
                            function(res){
                                _this.$indicator.close();
                                if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                                    // 使用以上方式判断前端返回,微信团队郑重提示：
                                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                    _this.abp.api.reqSuccess(_this,'支付成功,已通知商家发货')
                                }else if(res.err_msg == "get_brand_wcpay_request:cancel" ) {
                                    _this.abp.api.reqSuccess(_this,'您取消支付了,去我的订单查看')
                                }else if(res.err_msg == "get_brand_wcpay_request:fail" ) {
                                    _this.abp.api.reqSuccess(_this,'订单支付失败了,到我的订单完成支付')
                                }else{
                                    _this.abp.api.reqSuccess(_this,'支付缺少参数')
                                }
                                setTimeout(() => {
                                    _this.navbarItemClick()
                                }, 2000);
                            }
                        );
                    }else{
                        _this.$indicator.close();
                        _this.abp.api.reqSuccess(_this,'订单创建有误')
                    }
                } catch (txt) {
                    _this.$indicator.close();
                }
            } else {
                _this.$indicator.close();
                _this.abp.api.reqSuccess(_this,'订单创建有误')
            }
        }
    }
}
</script>

<style scoped>
    .my-order .mint-navbar.is-fixed {
        top: 0;
        left: 0;
        right: 0;
        overflow: hidden;
    }
    .my-order .mint-tab-container {
        top: 50px;
        background-color: #eee;
    }
    .my-order .mint-navbar {
        cursor: pointer;
    }
    .my-order .mint-navbar>a:hover {
        background-color: #c2dcf0;
        color: #fff;
    }
    .my-order .mint-navbar /deep/.mint-tab-item-label {
        font-size: 14px;
    }
    .my-order .mint-tab-container-item>h3 {
        color: #999;
        margin-top: 200px;
        text-align: center;
    }
    .mint-navbar /deep/.mint-tab-item.is-selected {
        color: #000;
        font-weight: 800;
        margin-bottom: 0px;
        border-bottom: 2px solid #26a2ff;
    }
    .my-order .mint-navbar>a:hover {
        color: #000;
        background-color: #fff;
    }
    .my-order table{
        table-layout: fixed;
        word-break: break-all;
        word-wrap: break-word;
    }
    .my-order .list-table {
        background-color: #fff;
        margin: 10px 5px 0;
        border-radius: 5px;
    }
    .my-order .list-table>.tab-header {
        display: flex;
        justify-content: space-between;
        height: 30px;
        align-items: center;
        font-size: 16px;
        padding: 5px 10px 0;
    }
    .my-order .list-table>.tab-header>div:first-child {
        flex: 3;
        font-size: 12px;
        color: #555;
    }
    .my-order .list-table>.tab-header>div:last-child {
        flex: 2;
        font-size: 14px;
        text-align: right;
        color: #e1777d;
    }
    .my-order .tab-school {
        background-color: #fff;
        border-top: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;
    }
    .my-order .tab-school>.area {
        display: flex;
        padding: 10px;
        font-size: 14px;
        color: #555;
    }
    .my-order .tab-school>.detail {
        display: flex;
        font-size: 16px;
        background-color: #fafafa;
    }
    .my-order .tab-school>.detail>div:first-child {
        width: 50px;
        height: 50px;
        margin: 10px;
    }
    .my-order .tab-school>.detail>div:first-child>* {
        width: 50px;
        height: 50px;
    }
    .my-order .tab-school>.detail>div:last-child {
        margin: 15px 5px;
        flex: 1;
        font-size: 14px;
        height: 40px;
        overflow: hidden;
        color: #555;
    }
    .my-order .tab-school>.time-num {
        display: flex;
        padding: 10px;
        font-size: 14px;
        color: #555;
        align-items: center;
    }
    .my-order .tab-school>.time-num>div:first-child {
        flex: 1;
        font-size: 12px;
    }
    .my-order .tab-school>.time-num>div:last-child {
        flex: 2;
        text-align: right;
    }
    .my-order .tab-school>.time-num>div:last-child .num {
        font-size: 12px;
    }
    .my-order .tab-school>.time-num>div:last-child>span:last-of-type {
        padding-left: 5px;
    }
    .my-order .tab-school>.time-num>div:last-child .price {
        font-size: 16px;
        font-weight: 600;
        color: #000;
    }
    /* .my-order .tab-school>div:first-child {
        width: 69px;
        font-size: 14px;
    }
    .my-order .tab-school>div:last-child {
        flex: 1;
    } */
    .my-order .tab-bot {
        padding: 10px 5px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    /* .my-order .tab-bot div.mouse-num {
        color: #000;
        flex: 1;
        font-size: 14px;
    } */
    .my-order .tab-bot div.cancel-pay,
    .my-order .tab-bot div.fin-pay {
        margin-right: 5px;
        width: 70px;
        height: 20px;
        border-radius: 10px;
        font-size: 12px;
        cursor: pointer;
        border: 1px solid #ada8a3;
        color: #72c34c;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .my-order .tab-bot div.cancel-pay {
        color: rgb(247, 113, 113);
    }
    .my-order .mint-tab-container {
        position: absolute;
        top: 50px;
        bottom: 0px;
        left: 0;
        right: 0;
        overflow: auto;
    }
</style>


